import React, { useState } from 'react';
import { MenuIcon, XIcon, RadioIcon } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageProvider';
import { LanguageToggle } from './LanguageToggle';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const {
    t
  } = useLanguage();
  const nav = [{
    label: t.nav.case,
    href: '#el-caso'
  }, {
    label: t.nav.pattern,
    href: '#el-patron'
  }, {
    label: t.nav.org,
    href: '#la-organizacion'
  }, {
    label: t.nav.method,
    href: '#el-metodo'
  }, {
    label: t.nav.timeline,
    href: '#linea-de-tiempo'
  }, {
    label: t.nav.contact,
    href: '#contacto'
  }];
  return <header className="w-full" data-id="element-94" data-mp="14xg9wugpco6r">
      <div className="bg-ink text-paper" data-id="element-95" data-mp="14uc09hkgx08p">
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-2 text-[11px] uppercase tracking-[0.18em]" data-id="element-96" data-mp="zwslmgjuylg8">
          <span className="flex items-center gap-1.5 text-accent" data-id="element-97" data-mp="2gaiue0lx9xw7">
            <RadioIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-98" data-mp="2bcr0x25mq3pw" />
            {t.topbar.status}
          </span>
          <span className="hidden text-paper/60 lg:inline" data-id="element-99" data-mp="29kbv1ovbb2ta">{t.topbar.subtitle}</span>
          <div className="ml-auto flex items-center gap-4" data-id="element-100" data-mp="2ein3bv5yl59e">
            <span className="hidden text-paper/60 sm:inline" data-id="element-101" data-mp="2eh2966nk3oc2">{t.topbar.place}</span>
            <LanguageToggle tone="dark" data-id="element-102" data-mp="2jij6xtaquuof" />
          </div>
        </div>
      </div>

      <div className="border-b-4 border-double border-ink bg-paper" data-id="element-103" data-mp="2og1jrurvtu1p">
        <div className="mx-auto max-w-6xl px-4 py-6" data-id="element-104" data-mp="1qtko0tysroi2">
          <div className="flex items-center justify-between gap-4" data-id="element-105" data-mp="1qv5heg9dl1ec">
            <a href="#top" className="group" data-id="element-106" data-mp="1vtgr8qzo7bwk">
              <p className="text-[10px] uppercase tracking-[0.35em] text-muted" data-id="element-107" data-mp="1vqay90nx7pvk">{t.brand.kicker}</p>
              <h1 className="font-serif text-3xl font-black leading-none tracking-tight sm:text-5xl" data-id="element-108" data-mp="20pnnfs29l91b">
                {t.brand.title} <span className="text-accent" data-id="element-109" data-mp="1832wuttm50yt">{t.brand.titleAccent}</span>
              </h1>
            </a>
            <button type="button" onClick={() => setOpen(v => !v)} className="rounded border border-ink/20 p-2 transition-colors hover:bg-ink hover:text-paper md:hidden" aria-expanded={open} aria-label={open ? t.menu.close : t.menu.open} data-id="element-110" data-mp="1d1nv4npb1akm">
              {open ? <XIcon className="h-5 w-5" data-id="element-111" data-mp="1epq2il64x0z4" /> : <MenuIcon className="h-5 w-5" data-id="element-112" data-mp="1et459uipnc73" />}
            </button>
          </div>
        </div>

        <nav aria-label={t.menu.sections} className="border-t border-ink/15" data-id="element-113" data-mp="19sq50yncp6jm">
          <ul className="mx-auto hidden max-w-6xl gap-6 px-4 py-2.5 text-[12px] font-semibold uppercase tracking-[0.14em] md:flex" data-id="element-114" data-mp="m35ffwwozb1d">
            {nav.map(item => <li key={item.href} data-id="element-115" data-mp="w131cdr2wvqt">
                <a href={item.href} className="border-b-2 border-transparent pb-0.5 transition-colors hover:border-accent hover:text-accent" data-id="element-116" data-mp="w24npedjp4nu">
                  {item.label}
                </a>
              </li>)}
          </ul>
          {open && <ul className="flex flex-col gap-1 px-4 pb-4 pt-2 text-sm font-semibold uppercase tracking-[0.12em] md:hidden" data-id="element-117" data-mp="22gc7g3kue54w">
              {nav.map(item => <li key={item.href} data-id="element-118" data-mp="2f099so150uqt">
                  <a href={item.href} onClick={() => setOpen(false)} className="block border-b border-ink/10 py-2 hover:text-accent" data-id="element-119" data-mp="2f0iym8ag4vux">
                    {item.label}
                  </a>
                </li>)}
              <li className="pt-3" data-id="element-120" data-mp="2sspfxxpc58vy">
                <LanguageToggle tone="light" data-id="element-121" data-mp="2xq8vd0xrrrph" />
              </li>
            </ul>}
        </nav>
      </div>
    </header>;
}